import React, { Suspense } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";

const AboutPage = React.lazy(() => import("./pages/AboutPage"));
const HomePage = React.lazy(() => import("./pages/HomePage"));
const OnboardingLayout = React.lazy(() => import("./pages/OnboardingLayout"));
const OnboardingStep = React.lazy(() => import("./pages/OnboardingStep"));
const SuccessPage = React.lazy(() => import("./pages/SuccessPage"));
const FailurePage = React.lazy(() => import("./pages/FailurePage"));

const theme = createTheme({
  palette: {
    primary: {
      main: "#2E7D32", // Un verde scuro che rappresenta la salute e il benessere
    },
    secondary: {
      main: "#81C784", // Un verde più chiaro e rilassante come colore di supporto
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2rem",
    },
    h2: {
      fontSize: "1.5rem",
    },
    body1: {
      fontSize: "1rem",
    },
  },
});

function AppShell() {
  const location = useLocation();
  const isOnboarding = location.pathname.startsWith("/onboarding");

  return (
    <div
      style={
        isOnboarding
          ? {
              height: "100dvh",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }
          : {
              minHeight: "100dvh",
              display: "flex",
              flexDirection: "column",
            }
      }
    >
      <Header />
      <main
        style={
          isOnboarding
            ? {
                flex: 1,
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }
            : {
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }
        }
      >
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route exact path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/onboarding" element={<OnboardingLayout />}>
              <Route path="step/:stepId" element={<OnboardingStep />} />
              <Route path="success" element={<SuccessPage />} />
              <Route path="failure" element={<FailurePage />} />
            </Route>
          </Routes>
        </Suspense>
      </main>
      {!isOnboarding && <Footer />}
    </div>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AppShell />
      </Router>
    </ThemeProvider>
  );
}

export default App;
